import React from 'react';
import { Info } from 'lucide-react';

export function HelpLimitations() {
  return (
    <section>
      <div className="flex items-center gap-2 mb-4">
        <Info className="w-5 h-5 text-indigo-500" />
        <h3 className="text-lg font-medium text-slate-900 dark:text-slate-100">App Limitations</h3>
      </div>
      
      <div className="space-y-3">
        <div className="p-4 rounded-xl border border-indigo-100 dark:border-indigo-500/20 bg-indigo-50/50 dark:bg-indigo-500/5">
          <ul className="space-y-3 text-sm text-slate-700 dark:text-slate-300">
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-indigo-500 mt-1.5 shrink-0" />
              <span><strong>Workspaces:</strong> You can have up to <strong>10 active workspaces</strong> at a time. If you reach this limit, you must delete an existing workspace to create a new one.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-indigo-500 mt-1.5 shrink-0" />
              <span><strong>Resumes per Workspace:</strong> You can upload and save up to <strong>10 total resumes</strong> inside each workspace at a time. If you hit this limit, you must delete an older resume.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-indigo-500 mt-1.5 shrink-0" />
              <span><strong>Data Storage:</strong> Data is saved locally in your browser. Browsers may clear this if storage is low or history is cleared. Please use the <strong>Export Data</strong> feature regularly to backup your workspaces and prevent data loss.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-indigo-500 mt-1.5 shrink-0" />
              <span><strong>Generation History:</strong> Undo/Redo history during tailoring is limited to the last <strong>10 versions</strong> to ensure optimal browser performance and save storage space.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-indigo-500 mt-1.5 shrink-0" />
              <span><strong>Saved Items:</strong> You can keep up to <strong>20 Saved Items</strong> per workspace. If you reach this limit, you must delete an older item before saving a new one.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-indigo-500 mt-1.5 shrink-0" />
              <span><strong>Free Tier:</strong> You receive 20 free credits when you sign up to analyze resumes and generate content. If you run out, you can top-up at any time.</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
